// Poste de garde sans réseau : les entrées et sorties sont gardées sur le téléphone (localStorage) et envoyées dans l'ordre
// dès que la connexion revient. Chaque action porte un identifiant (uid) : un renvoi ne crée jamais de doublon côté serveur.
// Un envoi refusé par le serveur reste en attente avec le message d'erreur, pour être supprimé ou réessayé.
import api from '../services/api';

const CLE = 'docc_garde_attente';
const CACHE = 'docc_garde_cache';
const EVT = 'docc-garde-file';
const URL = { entree: '/garde/entree', sortie: '/garde/sortie', pba: '/garde/pba/sortie', pbaNC: '/garde/pba/sortie-non-controlee' };

export const nouvelUid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`);
const pad = (n) => String(n).padStart(2, '0');
export const maintenant = () => { const d = new Date(); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`; };

export function lireFile() { try { const l = JSON.parse(localStorage.getItem(CLE) || '[]'); return Array.isArray(l) ? l : []; } catch { return []; } }
function ecrire(l) { try { localStorage.setItem(CLE, JSON.stringify(l)); } catch { /* stockage indisponible */ } window.dispatchEvent(new Event(EVT)); }
export function onFileChange(fn) { window.addEventListener(EVT, fn); window.addEventListener('storage', fn); return () => { window.removeEventListener(EVT, fn); window.removeEventListener('storage', fn); }; }
export function supprimer(uid) { ecrire(lireFile().filter((a) => a.payload.uid !== uid)); }
export function reessayer(uid) { const l = lireFile(); const a = l.find((x) => x.payload.uid === uid); if (a) { a.erreur = null; ecrire(l); } return envoyerFile(); }

/** Dernières listes connues (sur le site, employés, BC attendus) : l'écran reste utilisable sans réseau. */
export function lireCache() { try { return JSON.parse(localStorage.getItem(CACHE) || '{}') || {}; } catch { return {}; } }
export function majCache(x) { try { localStorage.setItem(CACHE, JSON.stringify({ ...lireCache(), ...x })); } catch { /* ignoré */ } }

let enCours = false;
export async function envoyerFile() {
  if (enCours || !localStorage.getItem('token')) return null;
  enCours = true; let envoyes = 0; const resultats = [];
  try {
    for (const a of lireFile()) {
      if (a.erreur) continue;
      try {
        // eslint-disable-next-line no-await-in-loop
        const r = await api.post(URL[a.type], a.payload);
        resultats.push({ ...a, reponse: r.data });
        ecrire(lireFile().filter((x) => x.payload.uid !== a.payload.uid)); envoyes += 1;
      } catch (e) {
        if (!e.response || e.response.status === 401) break; // pas de réseau, ou reconnexion nécessaire
        const l = lireFile(); const x = l.find((y) => y.payload.uid === a.payload.uid);
        if (x) { x.erreur = e.response.data?.error || `Refusé par le serveur (${e.response.status})`; ecrire(l); }
      }
    }
  } finally { enCours = false; }
  return { envoyes, restants: lireFile().length, resultats };
}

/**
 * Exécute une action : en ligne directement ; sans réseau (ou serveur injoignable), elle est mise en file d'attente.
 * Renvoie { data } (réponse du serveur) ou { horsLigne: true }. Une erreur du serveur (ex. champ manquant) est levée.
 */
export async function executer(type, payload, libelle) {
  const p = { ...payload, uid: payload.uid || nouvelUid(), le: payload.le || maintenant() };
  if (navigator.onLine && !lireFile().some((a) => !a.erreur)) {
    try { const r = await api.post(URL[type], p); return { data: r.data }; } catch (e) { if (e.response) throw e; }
  }
  ecrire([...lireFile(), { type, payload: p, libelle, cree_le: new Date().toISOString(), erreur: null }]);
  if (navigator.onLine) envoyerFile();
  return { horsLigne: true, uid: p.uid };
}

let demarre = false;
export function demarrerSynchro(apres) {
  if (demarre) return; demarre = true;
  const go = async () => { const r = await envoyerFile(); if (r?.envoyes && apres) apres(r); };
  window.addEventListener('online', go);
  setTimeout(() => { if (navigator.onLine) go(); }, 2000);
  setInterval(() => { if (navigator.onLine && lireFile().some((a) => !a.erreur)) go(); }, 30000);
}
